import { Component, OnInit } from "@angular/core";
import { NavController } from "@ionic/angular";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { FormBuilder, FormControl } from "@angular/forms";
import { FormValidations } from "../../../shared/form-validation/form-validation";
import { Title } from "@angular/platform-browser";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { ReturnNativeService } from "../../../shared/service/comunicator-native/return-native/return-native";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import {
  Keyboard,
  KeyboardResizeMode,
} from "@awesome-cordova-plugins/keyboard/ngx";
import { IncomeWealthService } from "../../service/income-wealth.service";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";

@Component({
  selector: "app-date-tax-residency",
  templateUrl: "./date-tax-residency.component.html",
  styleUrls: ["./date-tax-residency.component.scss"],
})
export class DateTaxResidencyComponent
  extends DefaultPageComponent
  implements OnInit
{
  public dataTaxRes = "";
  public idComponentName = "documentDateTaxResidency";
  placeholder = "00/00/0000";
  error = false;
  buttonEnable = false;
  textError = "";
  invalidErrorText = "Data inválida";
  idLabel = "dataTaxResLabel";
  label = "data de inicio de residência fiscal";
  startStage = "3";
  endStage = "3";
  idLabelDateTaxResidency = "idLabelDateTaxResidency";
  idButtonDateTaxResidency = "idButtonDateTaxResidency";

  dateTaxResForm = this.formBuilder.group({
    docDateTaxRes: this.formBuilder.control("", [
      FormValidations.validationsDate,
    ]),
  });

  headerId = "income-date-tax-res";
  titlePage = "Renda e patrimônio";
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;

  constructor(
    public router: NavController,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private formBuilder: FormBuilder,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    private keyBoard: Keyboard,
    public incomeWealthService: IncomeWealthService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.keyBoard.setResizeMode(KeyboardResizeMode.Body);
  }

  /* istanbul ignore next */
  get docDateTaxRes() {
    return this.dateTaxResForm.get("docDateTaxRes");
  }

  /* istanbul ignore next */
  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.editFieldInvest(
      "data_residencia_fiscal",
      "dateTaxResidency",
      "income"
    );
    this.getTrack();
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.dateTaxResidency;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  clickNext() {
    /* tslint:disable:no-string-literal */
    this.incomeWealthService.setDateTaxResidency(this.dataTaxRes);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.dateTaxResidency,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathDataNif,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  getPageId(): string {
    return this.headerId;
  }

  errorMsg() {
    const control = this.dateTaxResForm.get("docDateTaxRes") as FormControl;
    this.error = control.errors !== null;

    this.error ? (this.buttonEnable = false) : (this.buttonEnable = true);

    if (
      control.errors !== null &&
      control.errors.hasOwnProperty("dateInvalid")
    ) {
      this.textError = this.invalidErrorText;
    }
  }

  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();
    this.analyticsData();
    this.sendTrackGA4LoadPage();
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  submitForm($event: any) {
    $event.preventDefault();
    return false;
  }

  setEditPageRegistratio() {
    if (
      this.journeyService.registratioJourney.data.incomeEquity.dateTaxResidency
    ) {
      this.dataTaxRes =
        this.journeyService.registratioJourney.data.incomeEquity.dateTaxResidency;
      this.dateTaxResForm.controls.docDateTaxRes.setValue(
        this.journeyService.registratioJourney.data.incomeEquity
          .dateTaxResidency
      );
      this.errorMsg();
    }
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;

    if (track.getName() === TrackTypes.UPDATE_REGISTRATION) {
      this.startStage = "";
      this.endStage = "";
    }
  }
}
